import { useEffect } from "react";
import { Link } from "react-router-dom";
import assets from "../assets/assets";

const PrivacyPolicy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen py-8 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <div className="flex justify-center mb-6">
            <img
              src={assets.logo01}
              alt="Grainly Logo"
              className="h-16 w-auto"
            />
          </div>
          <h1 className="text-4xl font-bold text-gray-900 mb-4">
            Privacy Policy
          </h1>
          <p className="text-gray-600">
            Last updated: {new Date().toLocaleDateString()}
          </p>
        </div>

        <div className="bg-white rounded-lg shadow-md p-8 space-y-8">
          {/* 1. Introduction */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              1. Introduction
            </h2>
            <p className="text-gray-700 leading-relaxed">
              At <strong>Grainly</strong>, we respect your privacy. You can
              freely browse our website and explore our rice varieties without
              providing any personal information. We only collect essential
              details when you place an order — and only to ensure smooth and
              safe delivery to your location.
            </p>
          </section>

          {/* 2. Information We Collect */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              2. Information We Collect
            </h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              We collect only the information required to process and deliver
              your order:
            </p>
            <ul className="list-disc list-inside text-gray-700 space-y-1">
              <li>Your name (for delivery reference)</li>
              <li>Phone number (to confirm delivery and updates)</li>
              <li>Delivery address or location (for correct dispatch)</li>
              <li>Preferred payment method (Cash on Delivery or Online)</li>
            </ul>
          </section>

          {/* 3. How We Use This Information */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              3. How We Use This Information
            </h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              The collected information is used only for:
            </p>
            <ul className="list-disc list-inside text-gray-700 space-y-1">
              <li>Processing and confirming your rice orders</li>
              <li>Coordinating delivery to your address</li>
              <li>Contacting you for delivery confirmation or issues</li>
            </ul>
            <p className="text-gray-700 leading-relaxed mt-2">
              We do not sell, share, or use your personal details for marketing
              or any other purpose without your consent.
            </p>
          </section>

          {/* 4. Location Services */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              4. Location Services
            </h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              If you choose to use our “Auto Detect Location” feature, your
              location is used only to check whether your address is within our
              10km delivery range and to assist with accurate delivery.
            </p>
            <ul className="list-disc list-inside text-gray-700 space-y-1">
              <li>
                Your permission is required before accessing location data.
              </li>
              <li>Location data is never stored permanently on our servers.</li>
              <li>
                You can disable location access anytime in your browser
                settings.
              </li>
            </ul>
          </section>

          {/* 5. Data Security */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              5. Data Security
            </h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              We take appropriate steps to protect the personal data collected
              during order placement:
            </p>
            <ul className="list-disc list-inside text-gray-700 space-y-1">
              <li>Information is transmitted securely.</li>
              <li>
                Access to your details is limited to authorized personnel only.
              </li>
              <li>
                Data is retained only for completing the delivery and
                record-keeping.
              </li>
            </ul>
          </section>

          {/* 6. Data Sharing */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              6. Data Sharing
            </h2>
            <p className="text-gray-700 leading-relaxed">
              We share delivery information (name, address, phone number) only
              with trusted delivery partners to ensure successful delivery of
              your order. We may also use third-party services like Google Maps
              (for location) and WhatsApp (for sending order confirmations).
            </p>
          </section>

          {/* 7. Your Rights */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              7. Your Rights
            </h2>
            <ul className="list-disc list-inside text-gray-700 space-y-1">
              <li>Request to view or delete your stored order information</li>
              <li>Withdraw location access anytime</li>
              <li>Contact us for any privacy-related concerns</li>
            </ul>
          </section>

          {/* 8. Changes */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              8. Policy Updates
            </h2>
            <p className="text-gray-700 leading-relaxed">
              This Privacy Policy may be updated periodically. Any changes will
              be reflected on this page with an updated date.
            </p>
          </section>

          {/* 9. Contact */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              9. Contact Us
            </h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              For any privacy-related questions or requests, please visit our
              contact page:
            </p>
            <Link
              to="/contact"
              onClick={() => window.scrollTo(0, 0)}
              className="inline-flex items-center bg-[#305669] text-white px-6 py-3 rounded-lg hover:bg-[#1785A] transition-colors duration-200 font-medium shadow-md hover:shadow-lg"
            >
              Visit Contact Page
            </Link>
          </section>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
